import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { ReactComponent as Logo } from "../../Shared/Icons/logo.svg";
import * as tokenUtils from "utils/tokenUtils";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";

import styles from "./Header.module.scss";

const handleOnClickLogoutButton = (token, navigate) => {
  tokenUtils.removeToken();
  localStorage.clear();
  navigate("/login");
};
const handleOnClickHomeButton = (loggedIn, navigate) => {
  if (loggedIn) {
    navigate("/homePage");
  }
};
const Header = () => {
  const navigate = useNavigate();
  const loggedIn = tokenUtils.isValidUser();
  const token = Cookies.get("jweToken");

  return (
    <div className={styles.headerContainer}>
      <div className={styles.logoAndHomeIconContainer}>
        <Logo />
      </div>
      {loggedIn && (
        <div className={styles.actionItems}>
          <div
            className={styles.buttons}
            onClick={() => handleOnClickHomeButton(loggedIn, navigate)}
          >
            <HomeIcon /> Home
          </div>
          <div
            className={styles.buttons}
            onClick={() => handleOnClickLogoutButton(token, navigate)}
          >
            <LogoutIcon />
            Logout
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
